import {updateField} from 'vuex-map-fields';

export default {
    updateField,
    setPermissions (state, val) {
        state.permissions = val;
    },
    setUser (state, val) {
        state.user = val;
    },
    setCanApprove (state, val) {
        state.canApprove = val;
    },
    setUsers (state, val) {
        state.users = val;
    },
    setAnnouncements (state, val) {
        state.announcements = val;
    },
    setRanks (state, val) {
        state.ranks = val;
    },
    setInventoryTypes (state, val) {
        state.inventoryTypes = val;
    },
    setInventory (state, val) {
        state.inventory = val;
    },
    setCurrentTerm (state, val) {
        state.currentTerm = val;
        if (state.selectedTerms == null || state.selectedTerms.length == 0)
            state.selectedTerms = [val];
    },
    setTerms (state, val) {
        state.terms = val;
    },
    setObjectives (state, val) {
        state.objectives = val;
    },
    setLevels (state, val) {
        state.levels = val;
    },
    setEventTypes (state, val) {
        state.eventTypes = val;
    },
    setAttendanceTypes (state, val) {
        state.attendanceTypes = val;
    },
    setEvents (state, val) {
        state.events = val;
    },
    setAttendance (state, val) {
        state.attendance = val;
    },
    setPositions (state, val) {
        state.positions = val;
    },
    setUnits (state, val) {
        state.units = val;
    },
    setSelfUpdates (state, val) {
        state.selfUpdates = val;
    },
    setAdminUpdates (state, val) {
        state.admin_updates = val;
    },
    setApprovalUpdates (state, val) {
        state.approvalUpdates = val;
    },
    setPublishedUpdates (state, val) {
        state.publishedUpdates = val;
    },
    setDistributionList (state, val) {
        state.distributionList = val;
    },
    setDisputeTypes (state, val) {
        state.disputeTypes = val;
    },
    setDisputable (state, val) {
        state.disputable = val;
    },
    setSelfDisputes (state, val) {
        state.selfDisputes = val;
    }
}
